import { IconManager } from '@speeki/icons';

import nicoleAvatar from '@assets/images/nicole.png';

import { useTenantAvatar } from '@utils/hooks/useTenantAvatar';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';
import {
    MessageAvatarWrapper,
    MessageCustomAvatarImage,
    MessageNicoleWrapper,
    MessageSpeekiLogoIcon,
} from '@domains/new-conversation/atoms/SingleMessageAvatar/SingleMessageAvatar.styled';

export const SingleMessageAvatar = () => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    const { data: companyInformationData } = useTenantAvatar({
        fetchPolicy: 'cache-only',
        skip: !isLoggedIn,
    });

    const nicoleSetting =
        companyInformationData?.tenant.assetSettings.nicoleSetting;

    if (nicoleSetting === 'CUSTOM')
        return (
            <MessageAvatarWrapper>
                <MessageCustomAvatarImage
                    alt="CustomAvatar"
                    src={
                        companyInformationData?.tenant.assetSettings
                            .nicoleAvatarUrl ?? ''
                    }
                />
            </MessageAvatarWrapper>
        );
    if (nicoleSetting === 'DISABLED') {
        return (
            <MessageAvatarWrapper>
                <MessageSpeekiLogoIcon>
                    <IconManager
                        icon={'SvgSpeekiLogo'}
                        size={16}
                        themeColors={{
                            default: { 'color-5': 'main.secondary' },
                        }}
                    />
                </MessageSpeekiLogoIcon>
            </MessageAvatarWrapper>
        );
    }
    if (nicoleSetting === 'DEFAULT')
        return (
            <MessageNicoleWrapper>
                <img alt="Nicole" src={nicoleAvatar as string} />
            </MessageNicoleWrapper>
        );
    return <></>;
};
